import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import MenuItem from './item';
import * as Ui from './styles';

const propTypes = {
  type: PropTypes.oneOf(['employee', 'admin']),
  name: PropTypes.string,
  photo: PropTypes.string,
  menuItems: PropTypes.arrayOf(PropTypes.object),
  onLogout: PropTypes.func,
};

const defaultProps = {
  type: 'employee',
  name: 'User Name',
  photo:
    'https://ui-avatars.com/api/?name=Not+Defined&background=0D8ABC&color=fff',
  /*
  menuItemsformat
  {
    key: string,
    title: string,
    icon: componente,
    onClick: function,
    subItens:[]:menuItemsformat
  }
*/
  menuItems: [],
  onLogout: null,
};

export default function Avata(props) {
  // props
  const { type, name, photo, menuItems, onLogout, theme } = props;
  // state
  const [menuVisible, setMenuVisible] = useState(false);
  // refs
  const localRef = useRef();

  // format name
  function formatName(uname) {
    return uname.split(' ')[0];
  }

  // handle show menu
  function handleToggleMenu() {
    setMenuVisible(!menuVisible);
  }

  // handle logout item click
  function handleLogout() {
    if (onLogout) onLogout();
  }

  function handleClickOutside(e) {
    if (localRef.current && !localRef.current.contains(e.target)) {
      setMenuVisible(false);
    }
  }

  /**
   * Registrando listeners para fechar automaticamente o
   * menu ao tocar fora do componente
   */
  useEffect(() => {
    // ao tocar fora
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (
    <Ui.Container ref={localRef} onClick={() => handleToggleMenu()} className={menuVisible ? ' active-menu menu' : 'menu'}>
      {/* photo or avatar */}
      <Ui.Image background={photo} />
      {/* icon */}
      <Ui.ArrowDownIcon className={menuVisible ? 'active' : 'noActive'} />
      {/* menu */}
      <Ui.Menu className={menuVisible ? ' active' : ''} data-testid="user-menu">
        <Ui.MobileHeader className="mobile-header">
          <div className="user-identifier-wrapper">
            <Ui.OpenMenuImage background={photo} />
            <div className="user-greetings">
              <span className="greetings">Olá,</span>
              <span>{formatName(name)}</span>
            </div>
          </div>
          <span title="Fechar" className="settings-closer" onClick={() => handleToggleMenu()}>&times;</span>
        </Ui.MobileHeader>
        {/* others menu items */}
        {type === 'admin' || type === 'employee'
          ? menuItems.map((item) => (
            <MenuItem
              key={item.key}
              title={item.title}
              icon={item.icon}
              onClick={item.onClick}
              subItens={item.subItens}
              padding={item.padding}
              disabled={item.disabled}
              tooltip={item.tooltip}
              theme={theme}
            />
          ))
          : null}
        {/* logout menu item */}
        <MenuItem color={theme.colors.avataTextColorExit} title="sair" className="sair" icon={Ui.LogOutIcon} onClick={handleLogout} padding={'11px 20px 15px 20px'} />
      </Ui.Menu>
    </Ui.Container>
  );
}

Avata.propTypes = propTypes;
Avata.defaultProps = defaultProps;
